document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sgp-gallery').forEach(function (gallery) {
    var track = gallery.querySelector('.sgp-gallery-track');
    var dotsWrap = gallery.querySelector('.sgp-dots');
    var slides = track.querySelectorAll('.sgp-slide');
    if (!slides.length) return;

    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sgp-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Ver imagen ' + (i + 1));
      dot.addEventListener('click', function () {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start' });
      });
      dotsWrap.appendChild(dot);
    });

    var dots = dotsWrap.querySelectorAll('.sgp-dot');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = Array.prototype.indexOf.call(slides, entry.target);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
      });
    }, { root: track, threshold: 0.6 });

    slides.forEach(function (s) { observer.observe(s); });
  });

  // Variant select -> update hidden id input (single-variant products keep default)
  document.querySelectorAll('.sgp-variant-select').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form') || document.getElementById(select.getAttribute('form'));
      if (form) {
        var hidden = form.querySelector('input[name="id"]');
        if (hidden) hidden.value = select.value;
      }
    });
  });

  // Countdown de oferta (reinicia cada 24h)
  document.querySelectorAll('[data-sgp-countdown]').forEach(function (el) {
    var clock = el.querySelector('.sgp-offer-timer-clock');
    var endTs = parseInt(el.getAttribute('data-end'), 10) * 1000;
    if (!endTs) {
      var nowSecs = Math.floor(Date.now() / 1000);
      var secsLeft = 86400 - (nowSecs % 86400);
      endTs = (nowSecs + secsLeft) * 1000;
    }
    function tick() {
      var diff = endTs - Date.now();
      if (diff <= 0) { endTs += 86400000; diff = endTs - Date.now(); }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      clock.textContent = [h, m, s].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
    }
    tick();
    setInterval(tick, 1000);
  });

  // Lightbox de galería
  var lightbox = document.querySelector('[data-sgp-lightbox]');
  if (lightbox) {
    var lbImg = lightbox.querySelector('[data-sgp-lightbox-img]');
    var zoomables = Array.prototype.slice.call(document.querySelectorAll('.sgp-zoomable'));
    var current = 0;
    function openAt(i) {
      current = (i + zoomables.length) % zoomables.length;
      var src = zoomables[current].getAttribute('data-full') || zoomables[current].src;
      lbImg.src = src;
      lbImg.alt = zoomables[current].alt;
      lightbox.hidden = false;
    }
    zoomables.forEach(function (img, i) {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function () { openAt(i); });
    });
    var closeBtn = lightbox.querySelector('[data-sgp-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-sgp-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-sgp-lightbox-next]');
    if (closeBtn) closeBtn.addEventListener('click', function () { lightbox.hidden = true; });
    if (prevBtn) prevBtn.addEventListener('click', function () { openAt(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { openAt(current + 1); });
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) lightbox.hidden = true; });
    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') lightbox.hidden = true;
      if (e.key === 'ArrowLeft') openAt(current - 1);
      if (e.key === 'ArrowRight') openAt(current + 1);
    });
  }
});
